import { BAM_SERVICE_NAME } from './BamConsts';

// adds the serviceName to BAM logs.
// Additional fields added by infra: userId, loginTime, url, loginName, appVersion and accountId.

export default (loggerInstance, options = {}) => {
  if (loggerInstance && typeof loggerInstance.bam === 'function') {
    if (process.env.NODE_ENV === 'production') {
      loggerInstance.bam({
        ...options,
        serviceName: BAM_SERVICE_NAME,
      });
    } else {
      // console.log('BAM sendBam', { options });
    }
  }
};

// TODO avoid sending repeating BAMS with the same values - metrics
// TODO move BAM to web-worker thread to free up main thread
